import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import EditButton from "../../../backend/edit-button";
import Image from "../../image/image";

import BusinessWrapper from "../../../participants/components/business-wrapper";
import FeaturedEvents from "@default/js/participants/components/featured-events";

import CustomHyphenation from "@default/general-components/custom-hyphenation";
import { generateSpeakerName } from "@default/lib/generate-speaker-name";
import SimpleDesignLinkButton from "@default/js/simple-design/simple-design-link-button";
import useTranslate from "@default/hooks/use-translate";
import classNames from "classnames";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";

const TeaserSpeaker = ({ item, index, updateUrl }) => {
  const adminApp = useSelector((reduxStore) => reduxStore.appStore.adminApp);
  const isMobile = useSelector((reduxStore) => reduxStore.appStore.isMobile);
  const { simpleDesign } = useAccessibilityContext();

  const teaser = useRef();
  const teaserImage = useRef();

  const location = useLocation();
  const _t = useTranslate();

  return (
    <Link
      to={item.url?.path || item?.path?.alias}
      className={`node node-teaser teaser-speaker programme-element ${
        item.fieldImage ? "with-image" : "no-image"
      } col-12`}
      ref={teaser}
      data-entity-id={item.id}
    >
      <EditButton
        adminApp={adminApp}
        entityId={item.id}
        destinationRoute={location.pathname}
      />
      <div className="container">
        <div className="row">
          <div className="col-6 col-md-2 image" ref={teaserImage}>
            {item.fieldImage?.fieldMediaImage && (
              <Image
                data={item.fieldImage.fieldMediaImage}
                credit={item.fieldImage.fieldCredits}
                nodeTitle={item.title}
                styleSmall={true}
              />
            )}
          </div>
          {!isMobile && (
            <div
              className={classNames({
                "col-6 offset-6 offset-md-0 featured-events": true,
                "col-md-4 col-xl-3": simpleDesign,
                "col-md-3 col-xl-2": !simpleDesign,
              })}
            >
              <FeaturedEvents content={item} />
            </div>
          )}
          <div
            className={classNames({
              "col-6 main-infos": true,
              "col-md-6 col-xl-7": simpleDesign,
              "col-md-7 col-xl-8": !simpleDesign,
            })}
            >
            <div className="title-wrapper headline-s d-flex">
              <h2 className="name headline-m">
                <CustomHyphenation length={8}>
                  {generateSpeakerName(item)}
                </CustomHyphenation>
              </h2>
              {!isMobile && !!item.fieldCountry?.list?.length && (
                <>
                  {item.fieldCountry.list.map((country) => (
                    <div className="tag body-s" key={country}>
                      {country.value}
                    </div>
                  ))}
                </>
              )}
            </div>
            <BusinessWrapper content={item} />
            {isMobile && !!item.fieldCountry?.list?.length && (
              <>
                {item.fieldCountry.list.map((country) => (
                  <div className="tag body-s" key={country}>
                    {country.value}
                  </div>
                ))}
              </>
            )}

            <SimpleDesignLinkButton
              tabIndex={-1}
              label={`${_t("accessibility.more_about")} ${_t("accessibility.speaker")}`}
              size={"small"}
            />

          </div>
        </div>
      </div>
    </Link>
  );
};

export const teaserSpeakerPropTypes = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  updateUrl: PropTypes.bool,
  path: PropTypes.shape({
    alias: PropTypes.string,
  }),
  url: PropTypes.shape({
    path: PropTypes.string,
  }),
  fieldTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  fieldImage: PropTypes.shape({
    fieldMediaImage: PropTypes.shape({
      alt: PropTypes.string,
      title: PropTypes.string,
      style: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
    fieldCredits: PropTypes.string,
  }),
  fieldCountry: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }),
});

TeaserSpeaker.propTypes = {
  item: teaserSpeakerPropTypes,
  pagerFullPage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    .isRequired,
};

export default TeaserSpeaker;
